import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { IVesselInformationMySuffix } from 'src/app/shared/model/vessel-information-my-suffix.model';

@Component({
    selector: 'jhi-vessel-information-my-suffix-detail',
    templateUrl: './vessel-information-my-suffix-detail.component.html'
})
export class VesselInformationMySuffixDetailComponent implements OnInit {
    vesselInformation: IVesselInformationMySuffix;

    constructor(private activatedRoute: ActivatedRoute) { }

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ vesselInformation }) => {
            this.vesselInformation = vesselInformation;
        });
    }

    previousState() {
        window.history.back();
    }

    // history
    parentHistoryToggle = false;
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Vessel Informations (' + Obj.imoNumber + ') History';
        this.historyType = "VESSEL_INFORMATION_AUDIT";
        this.historyId = Obj.id;
    }
}
